import React, { CSSProperties, FC, useEffect } from 'react';
import useObserveOnboardingBannerStatus from '~/src/hooks/useObserveOnboardingBannerStatus';
import { CONFIG } from '~/src/services/adsense/constants';

export type AdBannerProps = {
  placement: string;
  slot: 'bannerRight' | 'bannerLeft' | 'bannerBottom';
  format?: 'rectangle' | 'horizontal' | 'vertical' | 'fluid';
  style?: CSSProperties;
};

const AdBanner: FC<AdBannerProps> = ({ style = {}, placement = '', format, slot }) => {
  const ref = useObserveOnboardingBannerStatus(placement);

  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      } else {
        window.adsbygoogle = [{}];
      }
    } catch (error) {
      console.log('Could not show an ad: ', (error as Error).message);
    }

    return () => {
      if (Array.isArray(window.adsbygoogle)) {
        window.adsbygoogle.pop();
      }
    };
  }, []);

  return (
    <ins
      ref={ref}
      className="adsbygoogle"
      style={{ display: 'block', zIndex: 2, ...style }}
      data-ad-client={CONFIG.publisherId}
      data-ad-slot={CONFIG.slot[slot]}
      data-ad-format={format || 'auto'}
      data-adtest={process.env.NEXT_RUNTIME !== 'production' ? 'on' : 'off'}
    />
  );
};

export default AdBanner;
